import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { cn } from '@/lib/utils';

interface FolderDropZoneProps {
  /** Droppable id; the target folder id, or 'root' for the category root. */
  id: string;
  /** The folder this zone drops into (null => category root). */
  folderId: string | null;
  className?: string;
  children: React.ReactNode;
}

/**
 * Thin wrapper that makes its children a drop target and highlights while a
 * dragged file hovers over it. Used by FolderNode rows and the root zone.
 */
export default function FolderDropZone({ id, folderId, className, children }: FolderDropZoneProps) {
  const { setNodeRef, isOver } = useDroppable({
    id,
    data: { type: 'folder', folderId },
  });

  return (
    <div
      ref={setNodeRef}
      className={cn(
        'rounded-xl transition-colors',
        isOver && 'ring-2 ring-primary ring-inset bg-primary/10',
        className,
      )}
    >
      {children}
    </div>
  );
}
